module.exports = __webpack_public_path__ + "media/images/inventory-icon-218a9bcd15a987a99c9ef685878655a7.svg";